var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrinter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4286 0.142857C11.4286 0.0642857 11.3643 0 11.2857 0H3.71429C3.63571 0 3.57143 0.0642857 3.57143 0.142857V2.78571H11.4286V0.142857ZM13.5714 3.92857H1.42857C0.639286 3.92857 0 4.56786 0 5.35714V11.2143C0 11.5304 0.255357 11.7857 0.571429 11.7857H3.57143V14.1429C3.57143 14.2214 3.63571 14.2857 3.71429 14.2857H11.2857C11.3643 14.2857 11.4286 14.2214 11.4286 14.1429V11.7857H14.4286C14.7446 11.7857 15 11.5304 15 11.2143V5.35714C15 4.56786 14.3607 3.92857 13.5714 3.92857ZM10.2143 13.0714H4.78571V8.14286H10.2143V13.0714ZM13.1429 6.64286C13.1429 6.72143 13.0786 6.78571 13 6.78571H12.2857C12.2071 6.78571 12.1429 6.72143 12.1429 6.64286V5.92857C12.1429 5.85 12.2071 5.78571 12.2857 5.78571H13C13.0786 5.78571 13.1429 5.85 13.1429 5.92857V6.64286Z",
    fill: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinter);
export default __webpack_public_path__ + "static/media/Printer.5c8dcf42c814159986141125b59a0047.svg";
export { ForwardRef as ReactComponent };